export default __webpack_public_path__ + "static/media/porte_pirate.cb1e3ed9.png";